import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Auth from './auth';

/**
 *
 * Component ini untuk melindungi Route dari akses yang tidak terautentikasi
 * @param {*} { component: Component, ...rest }
 * @returns
 */
function ProtectedRoute({
  component: Component,
  child: ChildComponent,
  ...rest
}) {
  const auth = new Auth();
  return (
    <Route
      { ...rest }
      render={ props =>
        auth.isAuthenticated() ? (
          <Component { ...props }>
            <ChildComponent { ...props } />
          </Component>
        ) : (
          <Redirect to='/' />
        )
      }
    />
  );
}

export default ProtectedRoute;
